import { render, staticRenderFns } from "./AddOrderToTripSelect.vue?vue&type=template&id=4ed4bbc6&scoped=true&"
import script from "./AddOrderToTripSelect.vue?vue&type=script&lang=js&"
export * from "./AddOrderToTripSelect.vue?vue&type=script&lang=js&"
import style0 from "./AddOrderToTripSelect.vue?vue&type=style&index=0&lang=css&"
import style1 from "./AddOrderToTripSelect.vue?vue&type=style&index=1&id=4ed4bbc6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ed4bbc6",
  null
  
)

/* custom blocks */
import block0 from "./AddOrderToTripSelect.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports